import { Star, ExternalLink } from "lucide-react";
import { GOOGLE_REVIEW_URL } from "@/lib/review-link";

type Props = {
  /** "card" = prominente Karte, "inline" = dezente Zeile im Footer */
  variant?: "card" | "inline";
};

/**
 * Call-to-Action: "Bewerten Sie uns auf Google".
 * Rendert sich nur, wenn `NEXT_PUBLIC_GOOGLE_REVIEW_URL` gesetzt ist oder
 * der Code-Fallback einen Wert hat – siehe src/lib/review-link.ts.
 */
export function ReviewPrompt({ variant = "card" }: Props) {
  if (!GOOGLE_REVIEW_URL) return null;

  if (variant === "inline") {
    return (
      <a
        href={GOOGLE_REVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 text-sm font-medium transition-colors hover:text-primary"
        style={{ color: "var(--text-secondary)" }}
      >
        <Star className="h-4 w-4" style={{ color: "#F59E0B" }} />
        Bewerten Sie uns auf Google
      </a>
    );
  }

  return (
    <div
      className="rounded-xl border p-6"
      style={{
        borderColor: "var(--border)",
        backgroundColor: "var(--card-bg)",
      }}
    >
      <div className="flex items-start gap-4">
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg"
          style={{
            backgroundColor: "rgba(245, 158, 11, 0.12)",
            color: "#F59E0B",
          }}
        >
          <Star className="h-5 w-5 fill-current" />
        </div>
        <div className="flex-1">
          <p
            className="text-base font-semibold"
            style={{ color: "var(--text)" }}
          >
            Hat Ihnen unsere Zusammenarbeit gefallen?
          </p>
          <p
            className="mt-1 text-sm"
            style={{ color: "var(--text-tertiary)" }}
          >
            Eine kurze Google-Bewertung hilft uns enorm und anderen
            Unternehmen bei der Entscheidung. Vielen Dank!
          </p>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-600"
          >
            <Star className="h-4 w-4 fill-current" />
            Auf Google bewerten
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </div>
      </div>
    </div>
  );
}
